import styled from '@emotion/styled';
import {Layout} from './Layout';

export const FixedAspect = styled(Layout)<{ratio: number}>`
    width: 100%;
    height: 0;
    padding-bottom: ${props => props.ratio * 100}%;
    position: relative;
`;
